import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <p>&copy; 2024 Nobos Software LLC. All rights reserved.</p>
      <nav className="footer-nav">
        <span>Available for opportunities and consulting</span>
      </nav>
    </footer>
  );
};

export default Footer;
